import { Controller } from "stimulus"
import Awesomplete    from 'awesomplete'

export default class extends Controller {
  static targets = [ "input" ]

  connect() {
      const list = JSON.parse(this.data.get('list'))

      this.awesomplete = new Awesomplete(this.inputTarget, {
      minChars: 0,
      maxItems: 50000,
      list: list,
      sort: false,
      replace: function(suggestion) {
        this.input.value = suggestion.label
        this.close();
      }
    })
  }

  setSelected(e) {
    this.inputTarget.classList.remove("invalid")
    if (e.text) {
      this.inputTarget.blur();
    }
  }

  showList() {
    if (this.awesomplete.ul.childNodes.length === 0) {
      this.awesomplete.minChars = 0
      this.awesomplete.evaluate()
    }
    else if (this.awesomplete.ul.hasAttribute('hidden')) {
      this.awesomplete.open()
    }
    else {
      this.awesomplete.close()
    }
  }
}
